﻿<template>
  <dropdown v-show="!showingAll" ref="dropdownRef" title="Add filter" placement="bottom-end">
    <quick-add-button size="small" />
    <template #content>
      <div>
        <h5>Filter by</h5>
        <ul>
          <li v-if="isMailbox && !showFilterSpam" @click="showFilterAndClose('showFilterSpam')">Spam</li>
          <li v-if="!showFilterWatching" @click="showFilterAndClose('showFilterWatching')">You're watching</li>
          <li v-if="!showFilterCreatedWithinDays" @click="showFilterAndClose('showFilterCreatedWithinDays')">Created within days</li>
          <li v-if="!showFilterLastUpdatedWithinDays" @click="showFilterAndClose('showFilterLastUpdatedWithinDays')">Last updated within days</li>
          <!-- Custom fields not yet shown as a filter -->
          <li
            v-for="field in customFieldOptions"
            :key="`custom-field-${field.id}`"
            @click="selectCustomFieldAndClose(field.id)"
          >{{ field.name }}</li>
        </ul>
      </div>
    </template>
  </dropdown>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { ICustomField } from '@/api/types/response.types'

/* API */

export default defineComponent({
  name: 'IfpPicker',

  props: {
    isMailbox: {
      type: Boolean,
      default: false,
    },
    showFilterSpam: {
      type: Boolean,
      required: true,
    },
    showFilterWatching: {
      type: Boolean,
      required: true,
    },
    showFilterCreatedWithinDays: {
      type: Boolean,
      required: true,
    },
    showFilterLastUpdatedWithinDays: {
      type: Boolean,
      required: true,
    },
    /* Filterable custom fields that are not currently exposed as a filter */
    customFieldOptions: {
      type: Array as () => ICustomField[],
      default: (): ICustomField[] => [],
    },
  },

  emits: [
    'custom-field-selected',
    'update:showFilterSpam',
    'update:showFilterWatching',
    'update:showFilterCreatedWithinDays',
    'update:showFilterLastUpdatedWithinDays',
  ],

  computed: {
    showingAll(): boolean {
      return (
        (!this.isMailbox || this.showFilterSpam) &&
        this.showFilterWatching &&
        this.showFilterCreatedWithinDays &&
        this.showFilterLastUpdatedWithinDays &&
        this.customFieldOptions.length === 0
      )
    },
  },

  methods: {
    showFilterAndClose(
      filterName: 'showFilterSpam' | 'showFilterWatching' | 'showFilterCreatedWithinDays' | 'showFilterLastUpdatedWithinDays',
    ) {
      this.$emit(`update:${filterName}`, true)
      this.handleCloseClick()
    },
    selectCustomFieldAndClose(fieldID: number) {
      this.$emit('custom-field-selected', fieldID)
      this.handleCloseClick()
    },
    handleCloseClick() {
      // @ts-ignore
      this.$refs.dropdownRef.handleClose()
    },
  },
})
</script>

<style lang="scss">
.dif-picker {
  &__button {
    display: flex;
    align-items: center;
    border-radius: 28px;
    padding: 0 6px;
    background-color: transparent;
    border: $border--dotted-dark;
    height: 28px;
    cursor: pointer;
    @include single-line-ellipsis;

    @include lettering--p-sm;

    > .ddi-plus {
      font-size: 12px;
    }
  }
}
</style>
